import { Renderers } from "../../components/crud/ResultsRenderers";
import { CRUD_FIELD_TYPES } from "../../constants";

export const displayName = (row) => {
  return `${row.name}`;
};

export function columns(modelName) {
  return [
    {
      field: "",
      headerName: "",
      width: 50,
      sortable: false,
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      resizeable: false,
      align: "center",
      renderCell: (params) => {
        return Renderers.ActionsRenderer(params, modelName);
      },
    },
    {
      field: "content_node_statuses.name",
      renderHeader: Renderers.StatusHelpIconRenderer,
      width: 20,
      sortable: false,
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      resizeable: false,
      align: "center",
      renderCell: Renderers.StatusDotRenderer,
    },
    {
      field: "id",
      hide: true,
    },
    {
      field: "created_at",
      hide: true,
    },
    {
      field: "updated_at",
      hide: true,
    },
    {
      field: "name",
      headerName: "Name",
      width: 150,
    },
    {
      field: "lat",
      headerName: "Latitude",
      width: 150,
    },
    {
      field: "lng",
      headerName: "Longitude",
      width: 150,
    },
  ];
}

export const fields = [
  {
    name: "Name",
    key: "name",
    required: true,
    type: CRUD_FIELD_TYPES.TEXT,
    cols: 12,
    isOpen: true,
  },
  {
    name: "Latitude",
    key: "lat",
    required: true,
    type: CRUD_FIELD_TYPES.NUMBER,
    cols: 6,
    isOpen: true,
  },
  {
    name: "Longitude",
    key: "lng",
    required: true,
    type: CRUD_FIELD_TYPES.NUMBER,
    cols: 6,
    isOpen: true,
  },
];

const config = {
  displayName,
  columns,
  fields,
};

export default config;
